/**
 * @description - Commercial Pricing Analyst Reducer.
 * @param {Object} state - State.
 * @returns {Object} - Updated state.
 */ const commercialPricingAnalystReducer = (state = {}) => state;
export default commercialPricingAnalystReducer;
